var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 70,
    viewBox: "0 0 85 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.8557 68H13.314C9.3537 68 7.37356 68 5.86094 67.2292C4.53041 66.5513 3.44866 65.4694 2.77072 64.1391C2 62.6263 2 60.6464 2 56.686V13.314C2 9.3537 2 7.37357 2.77072 5.86094C3.44866 4.53041 4.53041 3.44866 5.86094 2.77072C7.37356 2 9.3537 2 13.314 2H25.4405C27.2117 2 28.0973 2 28.9011 2.24415C29.6127 2.46024 30.2748 2.81461 30.8493 3.28687C31.4983 3.82032 31.9895 4.55719 32.972 6.03093L37.0261 12.1134C38.0086 13.5871 38.4998 14.324 39.1489 14.8575C39.7236 15.3297 40.3854 15.6841 41.0968 15.9002C41.901 16.1443 42.7864 16.1443 44.5575 16.1443H63.2858C65.476 16.1443 66.5711 16.1443 67.4696 16.3849C69.9111 17.0385 71.818 18.9454 72.4718 21.3869C72.7123 22.2854 72.7123 23.3805 72.7123 25.5708M30.2849 44.4274H63.284",
    stroke: "#005F6A",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8069 33.3072C12.7342 30.5254 13.1978 29.1342 14.0579 28.1061C14.8173 27.1978 15.7926 26.4948 16.8943 26.0616C18.1419 25.5709 19.6081 25.571 22.5406 25.571L69.4012 25.5723C74.7008 25.5724 77.3507 25.5725 79.0897 26.6819C80.6124 27.6531 81.7056 29.1701 82.1454 30.9214C82.6479 32.9225 81.8098 35.4366 80.1339 40.4642L73.5341 60.2637C72.6068 63.046 72.1434 64.4366 71.2831 65.4653C70.5236 66.3732 69.5487 67.0761 68.447 67.5093C67.1992 68.0001 65.7331 68.0001 62.8009 68.0001H15.9402C10.6406 68.0001 7.99074 68.0001 6.25131 66.8908C4.72869 65.9197 3.63538 64.4027 3.19555 62.6509C2.69307 60.6502 3.53101 58.1362 5.20684 53.1085L11.8069 33.3072Z",
    stroke: "#005F6A",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.01bd2417a0c36d62e1c50b24f31ba140.svg";
export { ForwardRef as ReactComponent };